import React, { Component } from 'react'
import Banner from '../../components/tribe/tribe_banner2'
import './css/index.css'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer' 
import Assestment2 from '../../assets/image/assestment2.png'
import center_assestment from '../../assets/image/assestment/assestment_center.jpg'
export default class assestment_center extends Component {
    render() {
        const image=[
            {image:center_assestment}
        ]
        return (
            <div>
                <Navbar/>
                <br/><br/><br/><br/><br className='hide-mobile'/><br className='hide-mobile'/>
                <div className='consulting-section'>
                    <Banner bread_crum={['Assessment','Assessment Center']} image={image} title="Assessment Center" subtitle=""/>
                    <br/><br/>
                    <div className='consulting-content'>
                        <h2>How we work</h2>
                        <br/><br/>
                        <div className='how'>
                            <p>
                                Assessment Center is the method for assessing one’s competence through several behavioral simulations that refers to the competencies needed for certain position.
                                <br/><br/>
                                Assessment Center Tools
                                <br/><br/>
                                <img src={Assestment2}/>
                                <br/><br/>
                                In house Workshop<br/>
                                Certified Assessment Center,BEI, Management of Assessment Center

                            </p>
                        </div>
                    </div>
                </div>
                <br/><br/>
                <Footer/>
            </div>
        )
    }
}
